import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { routerMiddleware, connectRouter } from "connected-react-router";
import createSagaMiddleware from "redux-saga";
import { all, fork } from "redux-saga/effects";
import {loadUserFromLocal} from "../utils/getAuth";
import { persistStore, persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import thunk from "redux-thunk";
import reducers from "./reducer";
import * as Sentry from "@sentry/react";
import * as LogRocket from "logrocket";

import {
    adminReducer,
    adminSaga,
} from "react-admin";


declare global {
    interface Window {
      __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}

export default ({
    dataProvider, historyHash
}) => {
    const rootReducer = combineReducers({
        ...reducers,
        admin: adminReducer,
        router: connectRouter(historyHash)
    });

    const persistedState = loadUserFromLocal();
    const persistConfig = {
        key: "root",
        storage: storageSession,
        blacklist: ["user"]
    };

    const sentryReduxEnhancer = Sentry.createReduxEnhancer();

    const persistedReducer = persistReducer(persistConfig, rootReducer);

    const saga = function* rootSaga() {
        yield all(
            [
                adminSaga(dataProvider, null),
                // add your own sagas here
            ].map(fork)
        );
    };
    const sagaMiddleware = createSagaMiddleware();
  
    const store = createStore(
        persistedReducer,
        {
            user: {
                ...persistedState
            }
        },
        compose(applyMiddleware(
            thunk,
            sagaMiddleware,
            routerMiddleware(historyHash),
            LogRocket.reduxMiddleware(),
        ), sentryReduxEnhancer)   
    );

    const persistor = persistStore(store);

    sagaMiddleware.run(saga);
    return {store, persistor};
};
